import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionAreaInspectionIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3 0a3 3 0 00-3 3v18a3 3 0 003 3h18a3 3 0 003-3V3a3 3 0 00-3-3H3zm4.037 13.396v4.699H4.289V4.76h5.202c1.002 0 1.881.183 2.638.55.763.366 1.35.888 1.759 1.565.409.672.613 1.438.613 2.3 0 1.306-.449 2.338-1.346 3.095-.891.75-2.128 1.126-3.71 1.126H7.038zm0-2.225H9.49c.727 0 1.28-.171 1.658-.513.385-.342.577-.83.577-1.465 0-.654-.192-1.182-.577-1.585-.384-.403-.916-.61-1.593-.623h-2.52v4.186zm9.104 2.565h.806c.384 0 .669-.096.853-.288.185-.192.278-.447.278-.764 0-.307-.093-.546-.278-.717-.181-.171-.432-.256-.753-.256-.29 0-.532.08-.728.24a.754.754 0 00-.293.618h-1.512c0-.398.106-.754.319-1.068.216-.317.516-.565.9-.743a3.02 3.02 0 011.277-.267c.806 0 1.438.194 1.895.581.457.384.685.914.685 1.591 0 .349-.106.67-.319.963a2.074 2.074 0 01-.837.675c.429.154.748.384.957.691.213.307.32.67.32 1.088 0 .677-.248 1.22-.743 1.628-.492.408-1.145.613-1.958.613-.76 0-1.383-.201-1.868-.602-.482-.402-.722-.932-.722-1.591h1.512c0 .286.106.52.32.7.216.182.48.273.795.273.36 0 .64-.094.842-.282.206-.192.31-.445.31-.76 0-.76-.42-1.14-1.257-1.14h-.8v-1.183z'
        />
    ),
})

TaskInspectionAreaInspectionIcon.displayName = 'TaskInspectionAreaInspectionIcon'
